import {Colors} from "@Styles/Colors.style";
import VehicleAddonType from "@CheckOrder/types/VehicleAddon.type";

export default function getSelectedVehicleIconData(vehicle: VehicleAddonType) {
    const mapVehiclesToIcons = {
        200: {title: "IconCar", stroke: Colors.neutralDarkestColor},
        201: {title: "IconCar", stroke: Colors.neutralDarkestColor},
        202: {title: "IconMotorcycle", fill: Colors.neutralDarkestColor},
        203: {title: "IconBicycle", stroke: Colors.neutralDarkestColor},
    }

    const iconAddonProps = mapVehiclesToIcons[vehicle.singlePassengerGroupId] ?? mapVehiclesToIcons[vehicle?.returnPassengerGroupId]

    return {iconAddonProps}
}